import { AppRoutes } from "@/types/routes";

export const getIsDashboardPage = () => {
    const currentPath = window.location.pathname;
    return currentPath === AppRoutes.Dashboard;
};

export const getIsYourJobsPage = () => {
    const currentPath = window.location.pathname;
    return currentPath.includes(`/${AppRoutes.YourJobs}`);
};

export const getIsAJobRelatedPage = () => {
    const isJobsPage = getIsJobsPage();
    const isYourJobsPage = getIsYourJobsPage();
    return isJobsPage || isYourJobsPage;
};

export const getIsJobsPage = () => {
    const currentPath = window.location.pathname;
    return currentPath.includes(`/${AppRoutes.Jobs}`);
};

export const getIsResumeBuilderPage = () => {
    const currentPath = window.location.pathname;
    return currentPath.includes("/resume");
};

export const getIsPreferencesPage = () => {
    const currentPath = window.location.pathname;
    return currentPath.includes(`/${AppRoutes.Preferences}`);
};

export const getIsProfilePage = () => {
    const currentPath = window.location.pathname;
    return currentPath.includes(`/${AppRoutes.Profile}`);
};

export const getIsSignUpPage = () => {
    const currentPath = window.location.pathname;
    return currentPath.includes(`/${AppRoutes.Signup}`);
};

export const getIsLoginPage = () => {
    const currentPath = window.location.pathname;
    return currentPath.includes(`/${AppRoutes.Login}`);
};

export const getIsResumePage = () => {
    const currentPath = window.location.pathname;
    return currentPath.includes(`/resume`);
};

export const getIsDesktopOnlyRoute = () => {
    const isResumePage = getIsResumePage();
    const isExamplesPage = getIsExamplesPage();

    return isResumePage || isExamplesPage;
};

export const getIsPreviewPage = () => {
    const currentPath = window.location.pathname;
    return currentPath.includes(`/preview`);
};

export const getIsExamplesPage = () => {
    const currentPath = window.location.pathname;
    return currentPath.includes(`/${AppRoutes.Examples}`);
};

export const getIsAResumePreviewPage = () => {
    const isDashboard = getIsDashboardPage();
    const isExamplesPage = getIsExamplesPage();
    return isDashboard || isExamplesPage;
};

export const getIsLivePreviewPage = () => {
    const currentPath = window.location.pathname;
    return currentPath.includes(`/${AppRoutes.LivePreview}`);
};
